import { render } from "./MenuEntrada.vue?vue&type=template&id=58bf42be"
import script from "./MenuEntrada.vue?vue&type=script&lang=js"
export * from "./MenuEntrada.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__